import { Button, Dropdown } from "antd";
import classNames from "classnames";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useApp from "../hooks/useApp";
import FaIcon from "./FaIcon";
import { faEllipsisH } from "@fortawesome/pro-light-svg-icons";
import Version from "./Version";
import MarkdownModal from "./MarkdownModal";
import { showHtml } from "../utils/showHtml";

import releaseNotesMd from "../../public/release-notes.md?raw";
import dependenciesMd from "../../public/DEPENDENCIES.md?raw";

// Ant Design Button override
const buttonOverrides =
  "w-[calc(100%-100px)] [&_button]:font-['Manrope',serif] [&_button]:text-sm [&_button]:font-light [&_button]:leading-[19px] [&_button]:tracking-normal [&_button]:text-center [&_button]:!text-[var(--primary)]";

export default function LegalStuff(props: { noWrapper?: boolean }) {
  const { t, i18n } = useTranslation();
  const { appData } = useApp();
  const [isReleaseNotesModalOpen, setIsReleaseNotesModalOpen] = useState(false);
  const [isDependenciesModalOpen, setIsDependenciesModalOpen] = useState(false);
  function legal() {
    showHtml("legalnotice");
  }

  function eula() {
    showHtml("eula_web");
  }

  function privacypolicy() {
    showHtml("privacypolicy_web");
  }

  function releaseNotes() {
    setIsReleaseNotesModalOpen(true);
  }

  function dependencies() {
    setIsDependenciesModalOpen(true);
  }

  const collapsed = appData?.collapsed;
  const noWrapper = props?.noWrapper;

  const content = [
    {
      key: "legal",
      label: (
        <div key={"legal"} onClick={legal}>
          {t("Legal notice")}
        </div>
      ),
    },
    {
      key: "eula",
      label: (
        <div key={"eula"} onClick={eula}>
          {t("EULA")}
        </div>
      ),
    },
    {
      key: "privacypolicy",
      label: (
        <div key={"privacypolicy"} onClick={privacypolicy}>
          {t("Privacy policy")}
        </div>
      ),
    },
    {
      key: "version",
      label: <Version />,
    },
  ];

  if (collapsed) {
    return (
      <Dropdown className={classNames("legal-wrapper", { collapsed })} menu={{ items: content }} trigger={["hover"]}>
        <Button icon={<FaIcon icon={faEllipsisH} size={"2x"} />} type={"link"} />
      </Dropdown>
    );
  }

  const buttons = (
    <>
      <Button type={"link"} onClick={legal}>
        {t("Legal notice")}
      </Button>
      <Button type={"link"} onClick={eula}>
        {t("EULA")}
      </Button>
      <Button className={"text-ellipsis"} type={"link"} onClick={privacypolicy}>
        {t("Privacy policy")}
      </Button>
      {appData?.auth && (
        <Button type={"link"} onClick={releaseNotes}>
          {t("Release notes")}
        </Button>
      )}
      <Button type={"link"} onClick={dependencies}>
        {t("Licenses")}
      </Button>
    </>
  );

  if (noWrapper) {
    return (
      <>
        {buttons}
        <MarkdownModal
          md={releaseNotesMd}
          open={isReleaseNotesModalOpen}
          splitMode="h1"
          title={t("Release notes")}
          onClose={() => setIsReleaseNotesModalOpen(false)}
        />
        <MarkdownModal
          md={dependenciesMd}
          open={isDependenciesModalOpen}
          splitMode="h1"
          title={t("Licenses")}
          onClose={() => setIsDependenciesModalOpen(false)}
        />
      </>
    );
  }
  return (
    <>
      <div className={classNames(buttonOverrides, "legal-wrapper", { collapsed })}>{buttons}</div>
      <MarkdownModal
        md={releaseNotesMd}
        open={isReleaseNotesModalOpen}
        splitMode="h1"
        title={t("Release notes")}
        onClose={() => setIsReleaseNotesModalOpen(false)}
      />
      <MarkdownModal
        md={dependenciesMd}
        open={isDependenciesModalOpen}
        splitMode="h1"
        title={t("Licenses")}
        onClose={() => setIsDependenciesModalOpen(false)}
      />
    </>
  );
}
